import { type FC } from "react";
import { useTranslation } from "react-i18next";
import { useFilter } from "@/partner/shared/components/Filter";
import { MapChartCard } from "@/partner/shared/components/MapChartCard";
import { useAnalyticsViewsByCountryQuery } from "@/partner/entities/analytics";

export const AnalyticsViewsByCountryMap: FC = () => {
  const { t } = useTranslation();
  const { filter } = useFilter();

  const { data, loading, error } = useAnalyticsViewsByCountryQuery({
    variables: { filter: filter as never, limit: 300 },
  });

  return (
    <MapChartCard
      title={t("analytics.views.mapByCountry")}
      data={data?.analyticsViews.viewsByCountry}
      loading={loading}
      error={error}
      field="views"
    />
  );
};
